import { omit } from "@mixitone/util";
import clsx from "clsx";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  indeterminate?: boolean;
};

export const Checkbox: React.FC<Props> = (props) => {
  return (
    <input
      type="checkbox"
      {...omit(props, ["indeterminate"])}
      className={clsx({
        indeterminate: props.indeterminate,
      })}
    />
  );
};
